module.exports = __webpack_public_path__ + "img/Twitter Icon.125027dd.svg";